import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from '../Services/apiSlice';
import rtkQueryErrorLogger from './LogErrorMiddleware';
import editorSlice from '../Components/FormEditor/Editor/editorSlice';
import formActionsSlice from '../Components/FormActions/formActionsSlice';
import formSlice from '../Components/FormSetup/formSlice';
import accountSlice from './account';

// eslint-disable-next-line import/prefer-default-export
export const store = configureStore({
  reducer: {
    editor: editorSlice,
    actions: formActionsSlice,
    form: formSlice,
    account: accountSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware, rtkQueryErrorLogger),
});
